import GitHUbImg from '../assets/svg/GitHub.png';
import LinkedIn from '../assets/svg/LinkedIn.png';
import Instagram from '../assets/svg/instagram.png';
import Twitter from '../assets/svg/twitter.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__social">
        <p className="footer__social--text">Follow me on</p>
        <div className="footer__social--links 
        
        "
        >
          <a href="https://github.com/JuanK81" target="_blank" rel="noreferrer">
            <img
              className="social-link__logo github"
              alt="logo"
              src={GitHUbImg}
            />
          </a>

          <a
            href="https://www.linkedin.com/in/juan-casals-dev/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="social-link__logo linkedin"
              alt="logo"
              src={LinkedIn}
            />
          </a>

          <a
            href="https://www.instagram.com/juandev_81/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="social-link__logo linkedin"
              alt="logo"
              src={Instagram}
            />
          </a>

          <a
            href="https://twitter.com/JuanDev81"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="social-link__logo linkedin"
              alt="logo"
              src={Twitter}
            />
          </a>
        </div>
      </div>
      <p className="footer__copy--text">&copy; Juan Casals</p>
    </footer>
  );
};

export default Footer;
